import {createFileRoute} from '@tanstack/react-router';
import {DepositAccountDirectTransferCallbackPage} from 'features/deposit/directTransfer/DepositAccountDirectTransferCallbackPage';

export const Route = createFileRoute('/_protected/direct-transfer/callback')({
  component: DepositAccountDirectTransferCallbackPage,
  validateSearch: (search) => {
    return {
      accountId: search.accountId as string | undefined,
      amount: search.amount as string | undefined,
      status: search.status as string | undefined,
    };
  },
});
